<div
  class="order-item-status"
  [class.delivered]="
    (order | getOrderItemStatus : orderItem) === orderStatuses.DELIVERED ||
    (order | getOrderItemStatus : orderItem) === orderStatuses.CONFIRMED ||
    (order | getOrderItemStatus : orderItem) === orderStatuses.PICKED_UP
  "
  [class.pending]="
    (order | getOrderItemStatus : orderItem) === orderStatuses.PENDING ||
    (order | getOrderItemStatus : orderItem) === orderStatuses.REFUNDED ||
    (order | getOrderItemStatus : orderItem) === orderStatuses.AWAITING_PAYMENT
  "
  [class.error]="
    (order | getOrderItemStatus : orderItem) === orderStatuses.PAYMENT_ERROR
  "
>
  <span class="label">{{
    "@components.orderList.orderItemStatus." +
      (order | getOrderItemStatus : orderItem) +
      ".label" | translate
  }}</span>
  <span class="value">{{
    "@components.orderList.orderItemStatus." +
      (order | getOrderItemStatus : orderItem) +
      ".value"
      | translate
        : {
            date:
              (order.type === orderTypes.DELIVERY
                ? orderItem.deliveredAt || orderItem.deliveryDate
                : orderItem.deliveredAt
              ) | date : "dd/MM/y"
          }
  }}</span>
</div>
